module.exports = __webpack_public_path__ + "img/gray-bg.cc60dc91.png";